if (!customElements.get('pino-delivery-quote')) {
  customElements.define('pino-delivery-quote', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      if (!form) return;
      this.scope = this.closest('product-info');
      try {
        this.variants = JSON.parse(this.querySelector('[data-pino-quote-variants]')?.textContent || '[]');
      } catch {
        this.variants = [];
      }
      if (!Array.isArray(this.variants)) this.variants = [];
      this.onVariantChange = (event) => {
        if (event.target?.matches?.('product-form input[name="id"]')) this.updateVariant();
      };
      this.scope?.addEventListener('change', this.onVariantChange);
      this.onSubmit = (event) => {
        if (!this.updateVariant()) event.preventDefault();
      };
      form.addEventListener('submit', this.onSubmit);
      this.onDestinationChange = (event) => {
        if (event.target?.matches?.('[data-pino-no-postcode]')) this.updateDestination();
      };
      form.addEventListener('change', this.onDestinationChange);
      this.updateDestination();
      this.updateVariant();
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('change', this.onVariantChange);
      this.querySelector('form')?.removeEventListener('submit', this.onSubmit);
      this.querySelector('form')?.removeEventListener('change', this.onDestinationChange);
      this.initialized = false;
    }
    updateDestination() {
      const noPostcode = this.querySelector('[data-pino-no-postcode]');
      const postcode = this.querySelector('[data-pino-quote-postcode]');
      const locality = this.querySelector('[data-pino-quote-locality]');
      const localityField = this.querySelector('[data-pino-quote-locality-field]');
      if (!noPostcode || !postcode || !locality || !localityField) return;
      postcode.disabled = noPostcode.checked;
      postcode.required = !noPostcode.checked;
      locality.disabled = !noPostcode.checked;
      locality.required = noPostcode.checked;
      localityField.hidden = !noPostcode.checked;
    }
    updateVariant() {
      const form = this.querySelector('form');
      const variantInput = this.scope?.querySelector('product-form input[name="id"]');
      const quantityInput = this.scope?.querySelector('input[name="quantity"]');
      const requestedVariant = form?.querySelector('[data-pino-quote-variant]');
      const requestedQuantity = form?.querySelector('[data-pino-quote-quantity]');
      const variantValue = variantInput ? variantInput.value : requestedVariant?.value;
      const selected = /^\d{1,20}$/.test(variantValue || '')
        ? this.variants.find((entry) => String(entry.id) === variantValue)
        : null;
      if (!selected || !requestedVariant) {
        if (requestedVariant) requestedVariant.value = '';
        if (requestedQuantity) requestedQuantity.value = '';
        this.hidden = true;
        return false;
      }
      requestedVariant.value = variantValue;
      const quantityValue = quantityInput ? quantityInput.value : requestedQuantity?.value;
      if (!/^[1-9]\d{0,8}$/.test(quantityValue || '') || !requestedQuantity || quantityInput?.checkValidity?.() === false) {
        if (requestedQuantity) requestedQuantity.value = '';
        quantityInput?.reportValidity?.();
        return false;
      }
      requestedQuantity.value = quantityValue;
      const isFinland = this.dataset.pinoCountry === 'FI';
      const emphasis = !isFinland && selected.family !== 'ordinary';
      this.hidden = selected.available === false || !selected.shipping || !(this.dataset.pinoFurniture === 'true' || selected.family !== 'ordinary');
      this.classList.toggle('pino-delivery-quote--emphasis', emphasis);
      const label = this.querySelector('[data-pino-quote-label]');
      const context = this.querySelector('[data-pino-quote-context]');
      if (label) label.textContent = isFinland ? this.dataset.pinoOptionalInternational : selected.family === 'freight' ? this.dataset.pinoFreightTitle : selected.family === 'arrangement' ? this.dataset.pinoArrangementTitle : this.dataset.pinoOptionalDelivery;
      if (context) {
        context.hidden = !emphasis;
        context.textContent = selected.family === 'arrangement' ? this.dataset.pinoArrangementContext : this.dataset.pinoFreightContext;
      }
      return !this.hidden;
    }
  });
}
